module.exports = __webpack_public_path__ + "media/images/application/schema/logo-d6479cc151a395a792eab172595fdc35.png";